// extracted by mini-css-extract-plugin
module.exports = {"errorLabel":"ErrorLabel_errorLabel__vzBPc"};